import { render, staticRenderFns } from "./FullPage.vue?vue&type=template&id=86315fc2&scoped=true&"
var script = {}
import style0 from "./FullPage.vue?vue&type=style&index=0&id=86315fc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86315fc2",
  null
  
)

export default component.exports